import { useRouteError } from 'react-router-dom';
import AppErrorView from './AppErrorView';

// errorElement for the router: replaces React Router's default
// "Unexpected Application Error!" screen.
export default function RouteErrorElement() {
  const error = useRouteError();

  return <AppErrorView error={error} />;
}
